// extracted by mini-css-extract-plugin
export default {"label":"SearchFilter_label__O71L1","filter":"SearchFilter_filter__J9zs7","filterContainer":"SearchFilter_filterContainer__WhYsu","resultCount":"SearchFilter_resultCount__c4+2A"};